import { memo } from "react";
import { AspectRatio, Box, Image, Text } from "@chakra-ui/react";
import Slider from "react-slick";

const ProductCollectionCarousel = ({ collections = [], onOpenCollection, autoplay = true, commonConfig = {} }) => {
    const items = collections.length === 1 ? [...collections, collections[0]] : collections;
    const roundImage = commonConfig?.round_image === true;
    const showName = commonConfig?.show_name !== false;

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay,
    };

    return (
        <Box style={{ width: "99%" }}>
            <Slider {...settings}>
                {items.map((item) => {
                    const image = item.avatar || item.image || item.banner;
                    return (
                        <div
                            key={item.id}
                            onClick={() => onOpenCollection(item)}
                            style={{ cursor: "pointer", padding: 4 }}
                        >
                            <AspectRatio ratio={4 / 3}>
                                <Image
                                    src={image?.md_url || image?.lg_url || image?.url}
                                    borderRadius={roundImage ? "full" : 8}
                                    objectFit="cover"
                                />
                            </AspectRatio>
                            {showName && (
                                <Text lineClamp={2} mt={2} textAlign="center" textStyle="sm" color="fg.muted">
                                    {item.title}
                                </Text>
                            )}
                        </div>
                    );
                })}
            </Slider>
        </Box>
    );
};

export default memo(ProductCollectionCarousel);
